module.exports = __webpack_public_path__ + "img/eurosender_publicAPI.010d9648.png";